'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ClientSideComponent = require('core/ClientSideComponent');

var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);

var _reactRedux = require('react-redux');

var _reactI18next = require('react-i18next');

var _auth = require('redux/modules/auth');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _index = require('components/index');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var CloudConnectButton = (_dec = (0, _reactRedux.connect)(null, { setBoxToken: _auth.setBoxToken, deleteBoxToken: _auth.deleteBoxToken }), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(CloudConnectButton, _Component);

  function CloudConnectButton() {
    var _ref;

    (0, _classCallCheck3.default)(this, CloudConnectButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = CloudConnectButton.__proto__ || (0, _getPrototypeOf2.default)(CloudConnectButton)).call.apply(_ref, [this].concat(args)));

    _this.state = { processing: false };
    return _this;
  }

  (0, _createClass3.default)(CloudConnectButton, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.accessToken && !this.props.isConnected) {
        this.onGetToken(nextProps.accessToken);
      }
    }
  }, {
    key: 'onGetToken',
    value: function onGetToken(accessToken) {
      var _this2 = this;

      if (this.state.processing) {
        return false;
      }

      this.setProcessing(true);
      this.props.setBoxToken(this.props.service, accessToken).promise.then(function () {
        return _this2.setProcessing(false);
      }).catch(function () {
        return _this2.setProcessing(false);
      });
    }
  }, {
    key: 'setProcessing',
    value: function setProcessing(processing) {
      if (this.state.isMounted) {
        this.setState({ processing: processing });
      }
    }
  }, {
    key: 'disconnect',
    value: function disconnect() {
      var _this3 = this;

      this.setProcessing(true);
      this.props.deleteBoxToken(this.props.service).promise.then(function () {
        return _this3.setProcessing(false);
      }).catch(function () {
        return _this3.setProcessing(false);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          isConnected = _props.isConnected,
          connectClassName = _props.connectClassName,
          disconnectClassName = _props.disconnectClassName;
      var processing = this.state.processing;

      var renderLoader = processing && _react2.default.createElement(_index.Loader, { small: true, mask: true });

      return !isConnected ? _react2.default.createElement(
        'button',
        { type: 'button', className: (0, _classnames2.default)(connectClassName, 'pos-rel'), onClick: this.props.connect, disabled: processing },
        t('Connect'),
        renderLoader
      ) : _react2.default.createElement(
        'button',
        { type: 'button', className: (0, _classnames2.default)(disconnectClassName, 'pos-rel'), onClick: this.disconnect, disabled: processing },
        t('Disconnect'),
        renderLoader
      );
    }
  }]);
  return CloudConnectButton;
}(_ClientSideComponent2.default), _class3.propTypes = {
  accessToken: _propTypes2.default.string,
  connect: _propTypes2.default.func,
  connectClassName: _propTypes2.default.string,
  deleteBoxToken: _propTypes2.default.func,
  disconnectClassName: _propTypes2.default.string,
  isConnected: _propTypes2.default.bool,
  service: _propTypes2.default.string,
  setBoxToken: _propTypes2.default.func,
  t: _propTypes2.default.func
}, _class3.defaultProps = {
  connectClassName: 'btn btn-primary btn-stroke squared wide small',
  disconnectClassName: 'btn btn-accent btn-stroke squared wide small'
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'disconnect', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'disconnect'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = CloudConnectButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Cloud/CloudConnectButton/CloudConnectButton.js
// module id = 1969
// module chunks = 1